import { MisterIcon } from "@rtel/mister-icons";

const styleLookup = {
  "primary": "btn-primary",
  "secondary": "btn-secondary",
  "dark": "btn-dark"
};

const sizeLookup = {
  "lg": "btn-lg",
  "sm": "btn-sm",
  "xl": "btn-xl"
};

const iconLookup = {
  "left": "iconleft",
  "right": "iconright"
};

const getButtonStyle = (styletype: styleType, disabled: boolean, size: sizeType, icon?: iconType) => {
  let styles = "";
  styles += `${styleLookup[styletype] || ''} `;
  styles += `${sizeLookup[size] || ''} `;
  if (disabled) { styles += "disabled " };
  if (icon) { styles += `${iconLookup[icon] || ''}` };

  return styles;
}

function Button(props: buttonProps) {
  return (
    <button
      type={props.type}
      className={`btn ${getButtonStyle(props.styletype, props.disabled, props.size, props.icon )} ${props.className}`}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.icon == "left" && <MisterIcon name="Plus" size="sm" />}
      {props.children}
      {props.icon == "right" && <MisterIcon name="Plus" size="sm" />}
    </button>
  );
}

interface buttonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type: buttonType;
  size: sizeType;
  className?: string;
  disabled: boolean;
  styletype: styleType;
  icon?: iconType;
}

type styleType = "primary" | "secondary" | "dark";
type iconType = "left" | "right";
type sizeType = "sm" | "lg" | "xl";
type buttonType = "button" | "submit";

Button.defaultProps = {
  type: "button",
  disabled: false,
  icon: null,
  className: ""
};

export default Button;
